import { i18n } from "@/fit-components/common/lang";

export enum LoadingType {
    Loading='loading',
    Security='security',
    Tick = 'tick',
    WechatPay = 'wechatPay',
}



export function getDefaultConfig() {
    return {
        // title
        type: LoadingType.Loading,
        show: false,
        title: i18n('加载中'),
        icon: 'loading',
    };
}
